<template>
  <div class="user-box">
    <ul class="select-option">
      <li>
        <el-input v-model="jobId" placeholder="任务ID" class="select-input" />
      </li>
      <li>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click.stop="search"
        >查询</el-button>
      </li>
      <li>
        <el-button type="warning" @click.prevent="back">返回</el-button>
      </li>
    </ul>

    <el-table
      ref="multipleTable"
      :data="tableData.records"
      border
      tooltip-effect="dark"
      style="width: 100%"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod"
        width="80"
        align="center"
      />
      <el-table-column label="日志ID" width="110" prop="logId" align="center" sortable />
      <el-table-column label="任务ID" width="110" prop="jobId" align="center" sortable />
      <el-table-column prop="beanName" label="bean名称" sortable />
      <el-table-column
        prop="methodName"
        label="方法名称"
        show-overflow-tooltip
        sortable
      />
      <el-table-column prop="params" label="参数" show-overflow-tooltip sortable />
      <el-table-column
        prop="status"
        label="状态"
        show-overflow-tooltip
        width="100"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status == 0"
            type="success"
            label="正常"
            effect="dark"
          >正常</el-tag>
          <el-tag v-else type="danger" label="禁用" effect="dark">禁用</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="times"
        label="耗时(单位:毫秒)"
        show-overflow-tooltip
        sortable
      />
      <el-table-column
        prop="createTime"
        label="执行时间"
        show-overflow-tooltip
        sortable
      />
    </el-table>
    <div style="text-align: center; margin-top: 25px">
      <el-pagination
        :page-size="tableData.size"
        :current-page="pageIndex"
        background
        layout="total,prev, pager, next, jumper"
        :total="tableData.total"
        @current-change="pageChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      limit: 10,
      pageIndex: 1,
      jobId: '',
      sidx: '',
      order: 'asc',
      tableData: {},
      selectRows: []
    }
  },

  created() {
    this.$emit('setCurrentMenu', '定时任务')
    this.getUserList(this.limit, this.pageIndex, this.jobId, this.sidx, this.order)
  },

  methods: {
    indexMethod(index) {
      return (this.pageIndex - 1) * this.limit + index + 1
    },

    getUserList(limit, pageIndex, jobId, sidx, order) {
      const vm = this
      vm.axios
        .get(this.homePath() + '/sys/scheduleLog/list', {
          params: {
            limit: limit,
            page: pageIndex,
            jobId: jobId,
            sidx: sidx,
            order: order
          }
        })
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.tableData = data.page
          } else if (data.status === '100000') {
            this.$alert(data.message, '提示', {
              confirmButtonText: '确定',
              callback() {
                vm.$router.push('/index/schedule')
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },

    search() {
      this.getUserList(this.limit, this.pageIndex, this.jobId, this.sidx, this.order)
    },

    back() {
      this.$router.push('/index/schedule')
    },

    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => c.rowIndex == row.rowIndex)
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },

    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },

    rowClassName({ row, rowIndex }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },

    selectionChange(rows) {
      this.selectRows = rows
    },

    pageChange(val) {
      this.pageIndex = val
      this.getUserList(this.limit, this.pageIndex, this.jobId, this.sidx, this.order)
    }
  }
}
</script>
